import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  FOOTER_NAV_SECONDARY,
  FOOTER_NAV_SOCIAL
} from 'components/layout/footer/Footer.constants';
import { useI18n } from 'hooks/useI18n';
import { useRouter } from 'next/dist/client/router';
import Link from 'next/link';
import React, { useEffect, useState } from 'react';
import { LOGO_MANFRED_WHITE } from 'utils/logos';
import {
  StyledFooter,
  StyledFooterContainer,
  StyledFooterCopyright,
  StyledFooterLogo,
  StyledFooterMain,
  StyledFooterNavCopy,
  StyledFooterNavItem,
  StyledFooterSecondary,
  StyledFooterSocial
} from './Footer.styled';

const Footer: React.FC = () => {
  const [year, setYear] = useState<number | null>(null);

  const { t } = useI18n('footer');
  const { locale } = useRouter();

  useEffect(() => {
    setYear(new Date().getFullYear());
  }, []);

  const footerNavSecondary = FOOTER_NAV_SECONDARY(t, locale);
  const footerNavSocial = FOOTER_NAV_SOCIAL();

  return (
    <>
      <StyledFooter>
        <StyledFooterContainer>
          <StyledFooterMain>
            <StyledFooterLogo>
              <img
                src={LOGO_MANFRED_WHITE}
                alt="Manfred logo"
                width="132"
                height="24"
              />
            </StyledFooterLogo>
          </StyledFooterMain>
          <StyledFooterNavCopy>
            <StyledFooterCopyright>
              &copy; {year} {t('nav.manfredTech')}
            </StyledFooterCopyright>
            <StyledFooterSecondary>
              <ul>
                {footerNavSecondary.map((navItem, index) => (
                  <li key={index}>
                    <Link href={navItem.href} passHref>
                      <StyledFooterNavItem>{navItem.title}</StyledFooterNavItem>
                    </Link>
                  </li>
                ))}
              </ul>
              <ul>
                {footerNavSocial.map((navItem, index) => (
                  <li key={index}>
                    <StyledFooterSocial
                      title={navItem.title}
                      href={navItem.href}
                      target="_blank"
                      rel="noreferrer noopener"
                    >
                      <FontAwesomeIcon icon={navItem.icon} />
                    </StyledFooterSocial>
                  </li>
                ))}
              </ul>
            </StyledFooterSecondary>
          </StyledFooterNavCopy>
        </StyledFooterContainer>
      </StyledFooter>
    </>
  );
};

export default Footer;
